<template>
  <span class="checklist__item-type-warn">
    {{ warnText }}
  </span>
</template>

<script>
export default {
  name: 'ChecklistsChecklistItemTypeWarn',

  props: {
    type: {
      type: String,
      default: 'client',
    },
  },

  computed: {
    warnText() {
      return this.type === 'client'
        ? this.$t('checklists.messages.type.client', { accountName: this.accountName })
        : this.$t('checklists.messages.type.diy')
    },

    accountName() {
      const cardId = this.$route.params.card_id
      // is template page ⤵
      if (!cardId) return 'el cliente'

      if (this.isClientPage) {
        return this.$store.state.client.account.name
      } else {
        return this.$store.getters['cards/getCard'](cardId).account.name
      }
    },

    isClientPage() {
      return this.$route.name === 'client-dashboard-modal'
    },
  },
}
</script>

<style scoped>
.checklist__item-type-warn {
  display: block;
  font-size: 11px;
  font-style: italic;
  font-weight: 600;
  color: var(--c-secondary);
}
</style>
